import { MatchesPlayers } from '@/modules/league/new-components/types';

export const getMatchColor = (
  player: MatchesPlayers,
  gameNumber: number,
  teamOrder: number[],
  team1Wins: number,
  team2Wins: number
): string | undefined => {
  const firstGame = Number(
    player[('Team_' + teamOrder[0] + '_Game' + gameNumber + 'Score') as keyof MatchesPlayers]
  );
  const secondGame = Number(
    player[('Team_' + teamOrder[1] + '_Game' + gameNumber + 'Score') as keyof MatchesPlayers]
  );
  const winBy = Number(player[('Game' + gameNumber + '_WinBy') as keyof MatchesPlayers]);
  const gameMax = Number(player[('Game' + gameNumber + '_Max') as keyof MatchesPlayers]);

  if (isNaN(firstGame) || isNaN(secondGame) || isNaN(winBy) || isNaN(gameMax)) {
    return;
  }

  if (firstGame === 0 && secondGame === 0 && player.Game_Best !== team1Wins + team2Wins) {
    return 'border-gray-400 text-gray-800';
  }

  if (
    winBy === 2 &&
    (firstGame > gameMax || secondGame > gameMax) &&
    Math.max(firstGame, secondGame) - Math.min(firstGame, secondGame) === winBy
  ) {
    if (firstGame > secondGame) return 'border-success-600 text-success-600 bg-success-50';

    return 'border-gray-400 text-gray-800';
  }

  if (
    (firstGame === gameMax && firstGame > secondGame && firstGame - secondGame >= winBy) ||
    (firstGame > gameMax && firstGame - secondGame >= winBy)
  ) {
    return 'border-success-600 text-success-600 bg-success-50';
  } else if (
    (secondGame === gameMax && secondGame > firstGame) ||
    (secondGame > gameMax && secondGame - firstGame === winBy)
  ) {
    return 'border-gray-400 text-gray-800';
  } else if (
    (firstGame !== gameMax || secondGame !== gameMax || firstGame === secondGame) &&
    (firstGame !== 0 || secondGame !== 0)
  ) {
    return 'border-error-500 text-error-500 bg-error-100';
  }
  return;
};
